// Capitalizes the first letter after every space (and the very start of
// the string) - e.g. "the abc company" -> "The Abc Company". Leaves the
// rest of each word untouched (not forced to lowercase) so existing
// intentional casing like acronyms/mixed-case brand names inside a word
// survive unchanged. Mirrors the backend's title_case() in
// supplier_onboarding_validators.py exactly - this is just immediate
// typing feedback, the backend re-applies the same rule as the source
// of truth regardless of what the frontend sends.
export const titleCase = (value) => {
  if (!value) return value;
  return value.replace(/(^|\s)([a-zA-Z])/g, (_, boundary, letter) => boundary + letter.toUpperCase());
};
